import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { crmConstants, crmModels } from '..';

export const useCrmFacebookAccount = () =>
  useQuery<crmModels.IFacebookAccount>({
    queryKey: [crmConstants.queryKeys.CRM_FACEBOOK_ACCOUNT],
    queryFn: async () => {
      const res = await $api.get('/v1/crm/facebook/account');

      return res?.data?.data;
    }
  });
